import { jsx as m } from "react/jsx-runtime";
import { forwardRef as g } from "react";
import { css as p, cx as f } from "@/styled-system/css";
import { headingRecipe as h } from "./heading.styles.js";
const x = g(
  (t, a) => {
    const {
      className: n,
      css: o,
      fontFamily: s = "sansSerif",
      level: e = 1,
      textStyle: r,
      ...i
    } = t, l = {
      1: "heading-xl",
      2: "heading-lg",
      3: "heading-md",
      4: "heading-sm",
      5: "heading-xs",
      6: "body-lg-bold"
    }, c = p(
      h.raw({ fontFamily: s, textStyle: r ?? l[e] }),
      o
    ), d = `h${e}`;
    return /* @__PURE__ */ m(
      d,
      {
        ref: a,
        "data-c11n-component": "Heading",
        "data-c11n-version": "10.0.0-alpha.19",
        className: f("c11n", c, n),
        ...i
      }
    );
  }
);
x.displayName = "Heading";
export {
  x as Heading
};
//# sourceMappingURL=heading.js.map
